export const defer = (cb: () => void) => setTimeout(cb, 0);
